import { render } from "./BaseWrapper.vue?vue&type=template&id=5db0504a&scoped=true"
const script = {}

import "./BaseWrapper.vue?vue&type=style&index=0&id=5db0504a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db0504a"]])

export default __exports__